(function (window) {
    "use strict";

    DSV.ui.focus = {

        rememberExistingFocus: function() {
          this.previousFocusedElement = document.activeElement;
        },

        setExistingFocus: function(){
            this.previousFocusedElement.focus();
        },

        trapFocus: function(element, namespace) {
            const focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'),
                firstFocusableEl = focusableEls[0],
                lastFocusableEl = focusableEls[focusableEls.length - 1],
                KEYCODE_TAB = 9;

            this.rememberExistingFocus();
            lastFocusableEl.focus();

            element.addEventListener('keydown', function(e) {
                const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

                if (!isTabPressed) {
                    return;
                }

                if ( e.shiftKey ) /* shift + tab */ {
                    if (document.activeElement === firstFocusableEl) {
                        lastFocusableEl.focus();
                        e.preventDefault();
                    }
                } else /* tab */ {
                    if (document.activeElement === lastFocusableEl) {
                        firstFocusableEl.focus();
                        e.preventDefault();
                    }
                }

            });
        }
    };
})(window);